import isUndefined from 'lodash/isUndefined';
import keys from 'lodash/keys';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import pickBy from 'lodash/pickBy';
import {useRouter} from 'next/router';
import Url from 'url-parse';

type DayOfWeekQueryParams = Partial<
  Record<'tab_id' | 'day_id' | 'sort_type' | 'page', string | undefined>
>;

export const useGetDayOfWeekQueryParams = () => {
  const router = useRouter();

  const getQueryString = (query: DayOfWeekQueryParams) => {
    const undefinedQueries: DayOfWeekQueryParams = pickBy(query, isUndefined);
    const availableQueries: DayOfWeekQueryParams = omitBy(query, isUndefined);

    const routerQuery = router.query;
    const filteredRouterQuery = omit(routerQuery, keys(undefinedQueries));
    const filteredRouterQueryString = Url.qs.stringify(filteredRouterQuery);

    const queryString = new URLSearchParams({
      ...Url.qs.parse(filteredRouterQueryString),
      ...availableQueries,
    }).toString();

    return {
      search: `?${queryString}`,
      queryString,
    };
  };

  return {getQueryString};
};
